module.exports = __webpack_public_path__ + "img/7.4fab068.png";